import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from "@mui/icons-material/History";
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Typography,
} from "@mui/material";

const statusColor = (status) => {
    if (status === "Joined") return { bg: "#e6f4ea", color: "#22A06B" };
    if (status === "Requested" || status === "Pending") return { bg: "#fff8e1", color: "#b38600" };
    if (["Removed", "Rejected", "Remove-Requested"].includes(status)) return { bg: "#ffeaea", color: "#d32f2f" };
    return { bg: "#f0f0f0", color: "#6f6c6c" };
};

const statusIcon = (status) => {
    if (status === "Joined") return "✓";
    if (status === "Requested" || status === "Pending") return "⏳";
    if (["Removed", "Rejected", "Remove-Requested"].includes(status)) return "❌";
    return "○";
};

const HistoryModal = ({ history = [] }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button
                variant="text"
                size="small"
                startIcon={<HistoryIcon />}
                onClick={() => setOpen(true)}
                sx={{
                    color: "#1976d2",
                    fontWeight: 500,
                    fontSize: "13px",
                    textTransform: "none",
                    minWidth: 0,
                    padding: "2px 8px",
                }}
            >
                Show History
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    Membership History
                    <IconButton onClick={() => setOpen(false)} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 0 }}>
                    {history && history.length > 0 ? (
                        <Box sx={{ maxHeight: 400, overflowY: "auto", p: 2 }}>
                            {history
                                .slice()
                                .reverse()
                                .map((h, idx) => {
                                    const { bg, color } = statusColor(h.status);
                                    return (
                                        <Box key={idx} sx={{ mb: 2 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <Box
                                                    sx={{
                                                        background: bg,
                                                        color,
                                                        borderRadius: 2,
                                                        px: 1.5,
                                                        py: 0.5,
                                                        fontWeight: 600,
                                                        fontSize: 13,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        minWidth: 90,
                                                    }}
                                                >
                                                    <span>{statusIcon(h.status)}</span>
                                                    {h.status}
                                                </Box>
                                                <Typography variant="body2" sx={{ color: "#888", ml: 1 }}>
                                                    {new Date(h.changed_date).toLocaleDateString()}
                                                </Typography>
                                            </Box>
                                            <Typography variant="body2" sx={{ color: "#555", mt: 0.5 }}>
                                                by <b>{h.changed_by}</b>
                                                {h.reason && (
                                                    <span style={{ color: "#b38600", marginLeft: 8 }}>
                                                        ({h.reason})
                                                    </span>
                                                )}
                                            </Typography>
                                            {idx < history.length - 1 && <Divider sx={{ my: 1 }} />}
                                        </Box>
                                    );
                                })}
                        </Box>
                    ) : (
                        <Typography sx={{ p: 2, color: "#888" }}>No history found.</Typography>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default HistoryModal;